




import { Component, Prop, Provide, Vue, Watch } from "vue-property-decorator";

@Component({})
export default class SuccessMessage extends Vue {
  @Prop() public lastSaved: Date | null;

  @Prop({ default: "Success" })
  public successText: string;

  private successMessage: boolean = false;

  @Watch("lastSaved", { deep: true })
  public onLastSaveChanged() {
    this.showSuccess();
  }

  public showSuccess() {
    this.successMessage = true;
    setTimeout(this.hideSuccess, 2000);
  }

  private hideSuccess() {
    this.successMessage = false;
  }
}
